import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["items", "transformItems"];
import React from 'react';
import { useSortBy } from 'react-instantsearch-hooks';
import { SortBy as SortByUiComponent } from "../ui/SortBy.js";
export function SortBy(_ref) {
  var items = _ref.items,
      transformItems = _ref.transformItems,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useSortBy = useSortBy({
    items: items,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.sortBy'
  }),
      currentRefinement = _useSortBy.currentRefinement,
      options = _useSortBy.options,
      refine = _useSortBy.refine;

  var uiProps = {
    items: options,
    value: currentRefinement,
    onChange: refine
  };
  return /*#__PURE__*/React.createElement(SortByUiComponent, _extends({}, props, uiProps));
}